import { useQuery } from "@tanstack/react-query";

import { getSportMappings } from "@/api/sportsNew";
import { SportsNewQueryKeys } from "./sportsNewQueryKeys";

export const useSportMappings = (sportId: number | null) => {
  return useQuery({
    queryKey: [SportsNewQueryKeys.SportMappings, sportId],
    queryFn: ({ signal }) => getSportMappings(sportId!, { signal, params: {} }),
    enabled: sportId !== null,
  });
};
